<div *ngIf="loaded && data.length > 0" [@loadedFadeAnimation]="'visible'" class="card-row row-4-2">
  <ng-container *ngFor="let item of data">
    <div [hidden]="showGallery" class="col">
      <div class="card">
        <img *ngIf="item.ImageFile" [src]="item.ImageFile.FileUri" class="card-img-top" alt="{{item.Title}}">
        <div class="card-body">
          <div class="card-title">{{item.Title}}</div>
          <div *ngIf="item.Content != null" class="card-text mt-n2">Localização: <strong>{{item.Content}}</strong></div>
        </div>
        <div class="card-footer">
          <div class="card-footer-text"><span *ngIf="item.ShowEventDate">{{item.EventDate | date: 'dd/MM/yyyy' }}</span></div>
          <a (click)="ShowGallery(item.IdEventDay)" class="btn btn-circle stretched-link"><fa-icon [icon]="['fas','chevron-right']"></fa-icon><span class="visually-hidden">Consulte</span></a>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<div class="lead" *ngIf="loaded && data.length == 0">Não há eventos disponíveis neste momento.</div>

<div *ngIf="!loaded" class="loading">
  <img src="assets/images/icons/ico_loading_bar.svg" />
</div>

<app-event-info (closeGallery)="GetCloseGallery($event)" [hidden]="!showGallery" [idData]="idEventDay">
</app-event-info>